import { defineStore } from 'pinia';
import axios from 'axios';
export const utilsStore = defineStore('utilsStore',{
    state: () => ({
        timezones: []
    }),
    actions: {
        getTimezones() {
            return axios.get(`/api/timegone`).then((resp)=> {
                this.timezones = resp.data;
            })
        },
    }
});